import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
export default select({
    optionState: function () { return store; },
})(action('selectComposeFormatOption')(function selectComposeFormatOption(value, state) {
    var optionState = state.optionState;
    optionState.composeFormat = value;
}));
//# sourceMappingURL=selectComposeFormatOption.js.map